<form [formGroup]="form" (ngSubmit)="saveAndContinue()">
  <div class="field-group">
    <label class="field-label">{{ 'company' | translate }}</label>
    <p-select
      formControlName="company"
      [options]="companyList()"
      optionLabel="description"
      [disabled]="showLoading() || changeStatus()"
      [placeholder]="'select_company' | translate"
      (onChange)="onCompanyChange()"
      class="w-100"
      [style]="{ width: '100%' }"></p-select>
    @if (form.get('company')?.touched && form.get('company')?.hasError('required')) {
      <div class="field-error">{{ 'required_field' | translate }}</div>
    }
  </div>

  <div class="field-group">
    <label class="field-label">{{ 'working_period' | translate }}</label>
    <p-select
      formControlName="workingPeriod"
      [options]="workingPeriodList()"
      optionLabel="description"
      [disabled]="showLoading()"
      [placeholder]="'select_working_period' | translate"
      class="w-100"
      [style]="{ width: '100%' }"></p-select>
    @if (form.get('workingPeriod')?.touched && form.get('workingPeriod')?.hasError('required')) {
      <div class="field-error">{{ 'required_field' | translate }}</div>
    }
  </div>

  <div class="actions">
    <button type="submit" class="btn-action" [disabled]="form.invalid || changeStatus() || showLoading()">
      <span>{{ 'continue' | translate }}</span>
      @if (showLoading()) {
        <i class="ph ph-spinner kl-input__icon-spin" aria-hidden="true"></i>
      } @else {
        <i [class]="isRtl() ? 'ph ph-arrow-left' : 'ph ph-arrow-right'" style="font-size: 1rem"></i>
      }
    </button>

    <button type="button" class="btn-ghost" [disabled]="changeStatus() || showLoading()" (click)="back()">
      <i [class]="isRtl() ? 'ph ph-arrow-right' : 'ph ph-arrow-left'" style="font-size: 1rem"></i>
      {{ 'exit' | translate }}
    </button>
  </div>

  @if (alertShow() && alertMessage()) {
    <div class="alert-error">{{ alertMessage() }}</div>
  }
</form>
